import React from 'react';
import { Link } from 'react-router-dom';

const RESOURCE_KEYS = [
  ['pastPapers', 'paper', 'papers'],
  ['quiz', 'quiz', 'quiz'],
  ['assignments', 'asgn', 'asgn'],
  ['labTasks', 'lab', 'labs'],
  ['books', 'book', 'books'],
  ['others', 'file', 'files'],
];

function resourceTags(data) {
  const tags = [];
  for (const [key, one, many] of RESOURCE_KEYS) {
    const n = Array.isArray(data?.[key]) ? data[key].length : 0;
    if (n) tags.push({ n, label: n === 1 ? one : many });
  }
  if (data?.CO_link || data?.CO_display) {
    tags.push({ n: null, label: 'outline' });
  }
  return tags;
}

function splitTitle(title) {
  const raw = title || 'Untitled';
  const match = raw.match(/^(.*?)\s*\(([^)]+)\)\s*$/);
  if (!match) return { name: raw, code: null };
  return { name: match[1], code: match[2] };
}

const CardComp = ({ isAdmin, data: rawData, loading }) => {
  if (loading) {
    return (
      <div className="skeleton-card">
        <div className="skel-line skel-title skeleton" />
        <div className="skel-line skel-desc1 skeleton" />
      </div>
    );
  }

  const data = rawData?.data || {};
  const { name, code } = splitTitle(data.title);
  const description = (data.description || '').trim();
  const tags = resourceTags(data);

  return (
    <article className="paper-card">
      <Link
        className="paper-card-link"
        to={`/paper?id=${encodeURIComponent(data.id)}`}
        state={data}
      >
        <div className="card-body">
          <div className="card-name">
            <h2 className="card-title">{name}</h2>
            {code ? <span className="card-code">{code}</span> : null}
          </div>
          {description ? <p className="card-desc">{description}</p> : null}
          {tags.length ? (
            <div className="card-tags">
              {tags.map(({ n, label }) => (
                <span key={label} className="card-tag">
                  {n != null ? <b>{n}</b> : null}
                  {label}
                </span>
              ))}
            </div>
          ) : null}
        </div>
        <span className="card-action">
          Open
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true">
            <path d="M5 12h14M12 5l7 7-7 7" />
          </svg>
        </span>
      </Link>
      {isAdmin && (
        <Link
          className="card-edit"
          to="/addData"
          state={data}
        >
          Edit
        </Link>
      )}
    </article>
  );
};

export default CardComp;
